/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOrgCapabilitiesDeployments { 
    version_selection_allowed?: boolean;
    /**
     * Allow import of deployments into service plane.
     */
    import_allowed?: boolean;
    /**
     * Allow tenant to reconfigure IRR.
     */
    irr_reconfigure_allowed?: boolean;
    num_parallel_deployments_allowed?: number;
    /**
     * List of all personas allowed for deployment
     */
    personas_allowed?: string;
    /**
     * Maximum number of on-premises deployments allowed
     */
    allowed_onprem_count?: number;
    /**
     * Whether SRM pairing is required for deployments
     */
    srm_pair_required?: boolean;
}

